// RoleList.js
import { useState, useEffect } from "react";
import List from "../../../common/list";
import { TextInput } from "../../../common/fields";
import { Button } from "primereact/button";

const UserList = ({
  users = [],
  totalCount = 0,
  query,
  setQuery,
  fetchUsers,
  selectedUsers,
  setSelectedUsers,
  preSelectedIds = [],
  onSave,
  onCancel,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredUsers, setFilteredUsers] = useState(users);


  console.log({
  users ,
  totalCount ,
  query,
  setQuery,
  fetchUsers,
  selectedUsers,
  setSelectedUsers,
  preSelectedIds ,
  onSave,
  onCancel,
},"-------->soham debugger userlist")

  // Update filteredRoles when roles change or search term changes
  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredUsers(users);
    } else {
      const filtered = users.filter((r) =>
        r.name?.toLowerCase().includes(searchTerm?.toLowerCase())
      );
      setFilteredUsers(filtered);
    }
  }, [users, searchTerm]);

  // Preselect roles (like in edit)
  useEffect(() => {
    if (preSelectedIds?.length) {
      const preselected = users.filter((r) => preSelectedIds.includes(r.id));
      setSelectedUsers(preselected);
    }
  }, [users, preSelectedIds, setSelectedUsers]);

  // Debounced search (like UserList example)
  useEffect(() => {
    const timer = setTimeout(() => {
      if (query.search !== searchTerm) {
        setQuery({ ...query, search: searchTerm, pageNo: 1 });
        fetchUsers?.(searchTerm);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [searchTerm, fetchUsers, setQuery, query.search]);

  const handlePageChange = (pageData) => {
    if (query.pageSize !== pageData.rows || query.pageNo !== pageData.page + 1) {
      setQuery({ ...query, pageNo: pageData.page + 1, pageSize: pageData.rows });
    }
  };

  return (
    <div>
      <div className="edexlms-search-filter-bar mb-4 flex">
        <TextInput
          icon="pi pi-search"
          placeholder="Search Users"
          input={{ value: searchTerm, onChange: (e) => setSearchTerm(e.target.value) }}
        />
      </div>

      <List
        data={filteredUsers}
        totalRecords={totalCount}
        pageQuery={query}
        handlePageChange={handlePageChange}
        selectionMode="checkbox"
        selectedRecords={selectedUsers}
        onSelectionChange={(e) => {
          setSelectedUsers(e.value)
        }}
        columns={[
          {
            field: "name",
            header: "Name",
            body: (rowData) => (
        <div>
          <div className="font-medium">{rowData.name}</div>
          <div className="text-sm text-gray-500">{rowData.email}</div>
        </div>
      ),
    
          },
          // {
          //   field: "userCount",
          //   header: "User Count",
          //   body: (rowData) => <div>{rowData.userCount ?? 0}</div>,
          // },
        ]}
      />

      <div className="flex justify-end mt-4 gap-2">
        <Button label="Cancel" onClick={onCancel} className="p-button-text" />
        <Button label="Save" onClick={() => onSave(selectedUsers)} />
      </div>
    </div>
  );
};

export default UserList;
